import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { convertTime } from '../../shared/util/helperfunctions';

export function AuthorContainer({ author }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="author">
      <div
        role="group"
        className="author-about"
        aria-labelledby={`author-heading-${author.author_shortcode}`}
      >
        <div className="author-img" style={{ backgroundImage: `url(${author.author_image})` }} />
        <div className="author-bio">
          <h2
            className="author-name"
            id={`author-heading-${author.author_shortcode}`}
          >{`${t('M020')} ${author.author}`}</h2>
          <p>{author.author_title}</p>
          <p>{author.description}</p>
          <p>
            <Link to={`/authors/${author.author_shortcode}`}>
              {t('M020')} {author.author.split(' ')[0]}{' '}
              <FontAwesomeIcon icon={faArrowRight} className="icon " aria-hidden="true" />
            </Link>
          </p>
        </div>
      </div>
      {author.content?.length > 0 && (
        <div className="library" role="group" aria-label={`${t('M073W')}`}>
          <h2>{t('M073W')}</h2>
          <div className="scrollable">
            {author?.content?.map((item, index) => {
              const contentLink = `/${
                item?.category?.toLowerCase() === 'masterclass'
                  ? 'masterclass'
                  : item?.category?.toLowerCase() === 'programme'
                    ? 'programme'
                    : 'media'
              }/${item?.chid}/${item?.title.replace(/ /g, '_')}`;
              return (
                <div className="content" key={index}>
                  <Link to={contentLink} className="content-link">
                    <span className="sr-only">
                      {t('SLD004')} {item?.title}
                    </span>
                  </Link>
                  <div
                    className="content-img"
                    style={{
                      backgroundImage: `url(${item?.thumbnail_image})`,
                    }}
                  />
                  <div className="text">
                    <p
                      id={`author-content-title-${index}`}
                      className={`text-title ${item?.length ? '' : 'text-title-notime'}`}
                    >
                      {item?.title}
                    </p>
                    {item?.length && <p>{convertTime(item?.length)}</p>}
                    <p>{item?.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
